<template>
  <div class="walletconnect">
    <WalletConnectInfoModal
      :infoModal="infoModal"
      @handleShowChange="handleShowChange"
    />
    <box-loader
      ref="boxLoader"
      :title="loaderTitle"
      :error="onImgError"
      :icon="getLiveIcon(walletInfo)"
      :description="loaderDescription || ''"
      :buttonText="loaderButtonText"
      @hide="cancelPay()"
    />
    <div class="pt-2" />
    <div v-if="!hash">
      <div
        class="walletconnect__connection_container"
        v-if="!showsConnectedPayment"
      >
        <div class="walletconnect__connect-card">
          <button
            type="button"
            class="walletconnect__connect-main"
            @click="openModal"
          >
            <span class="walletconnect__wallet_icon-wrap">
              <img
                class="walletconnect__wallet_icon"
                src="@/assets/img/wallets/walletConnect.svg"
                alt=""
              />
            </span>
            <span class="walletconnect__connect-copy">
              <span class="walletconnect__wallet_name">
                {{ $t("walletconnect.walletConnect") }}
              </span>
              <span class="walletconnect__wallet_name_sub">
                {{ $t("walletconnect.connectAndPayFaster") }}
              </span>
            </span>
          </button>
          <button
            type="button"
            class="walletconnect__info-btn"
            :aria-label="$t('walletconnect.walletConnectTooltip')"
            @click="handleShowInfoModal(true)"
          >
            <img
              class="walletconnect__icon_info"
              src="@/assets/img/info_blue.svg"
              alt=""
              id="info"
            />
          </button>
          <b-tooltip target="info" triggers="hover" placement="left">
            {{ $t("walletconnect.walletConnectTooltip") }}
          </b-tooltip>
        </div>
      </div>
      <div v-else-if="showsConnectedPayment">
        <div
          class="walletconnect__connected d-flex flex-row justify-content-between align-items-center"
        >
          <div class="walletconnect__connected_container">
            <img
              class="walletconnect__wallet_icon_connected"
              :src="getLiveIcon(walletInfo)"
              @error="onImgError"
              alt=""
            />
            <div class="walletconnect__wallet_title_connected">
              {{ walletInfo?.name || "WalletConnect" }}
            </div>
          </div>
          <div>
            <div class="walletconnect__wallet_network">
              {{ $t("walletconnect.switchNetwork") }}
            </div>
            <appkit-network-button class="walletconnect__wallet_network" />
          </div>
        </div>
        <div class="badge rounded-pill bg-dark walletconnect__wallet_account">
          {{ $t("walletconnect.account") }} {{ getWrappedText(address) }}
        </div>
        <!-- Balance Error Widget -->
        <div
          v-if="
            balanceError &&
            isConnected &&
            !error?.message &&
            !customErrorMessage
          "
          class="walletconnect__balance_error mt-1"
        >
          <div class="d-flex flex-row align-items-center">
            <img
              src="@/assets/img/info-2.svg"
              alt="error"
              class="walletconnect__balance_error_icon"
            />
            <div class="walletconnect__balance_error_text">
              {{
                balanceErrorMessage ||
                $t("walletconnect.balanceCannotBeListed") ||
                "Your balance cannot be listed. Please try again later."
              }}
            </div>
          </div>
        </div>
        <div
          class="walletconnect__amount_container mt-2"
          v-if="(tokens?.length || selectedToken) && !balanceError"
          @click="showDropdown = !showDropdown"
        >
          <div class="d-flex flex-row align-items-center">
            <img
              v-if="selectedToken"
              :src="selectedToken?.logo"
              alt=""
              class="walletconnect__currency_icon"
            />
            <div class="walletconnct__currency_text">
              {{ selectedToken?.symbol }}
            </div>
          </div>
          <div class="d-flex flex-row align-items-center">
            <div class="d-flex flex-column mr-2">
              <div class="walletconnect__balance_crypto">
                {{
                  NumberFormat(
                    DecimalNumber(
                      selectedToken?.formatted ||
                        selectedToken?.tokenBalance ||
                        0
                    ).toFixed(6)
                  )
                }}
                {{ selectedToken?.symbol }}
              </div>
              <!-- <div class="walletconnect__balance_usd">
                {{ NumberFormat(
                  DecimalNumber(selectedToken?.formatted || selectedToken?.tokenBalance || 0)
                    .mul(selectedToken?.currentRate || 0).toFixed(2),
                  2) }} USD
              </div> -->
            </div>
            <img
              alt=""
              src="@/assets/img/down-arrow1.svg"
              class="walletconnect__currency_icon"
            />
          </div>
        </div>

        <b-collapse
          class="cs-dd__options"
          role="tabpanel"
          id="my-accordion"
          v-if="tokens?.length"
          v-model:open="showDropdown"
        >
          <div
            v-for="(token, i) in tokens"
            v-bind:key="i"
            class="walletconnect__select"
            @click="handleSelectToken(token)"
          >
            <div class="d-flex flex-row align-items-center">
              <img
                alt=""
                :src="token.logo || require('@/assets/img/info-2.svg')"
                class="walletconnect__select_currency_icon"
              />
              <div class="w-100">{{ token.symbol }}</div>
            </div>
            <div class="walletconnect__select_balance" v-if="token.logo">
              {{
                parseFloat(token.formatted || token?.tokenBalance || 0).toFixed(
                  5
                )
              }}
              {{ token.symbol }}
            </div>
            <div class="walletconnect__select_balance disabled" v-else>
              <i>Not supported</i>
            </div>
          </div>
        </b-collapse>
        <div
          class="walletconnect__balance_text mb-2 mt-3 d-flex flex-row justify-content-between"
          v-if="selectedToken"
        >
          <div class="walletconnect__label">
            {{ $t("walletconnect.conversionRate") }}
          </div>
          <div v-if="exchangeRateLabel" class="walletconnect__value">
            {{ exchangeRateLabel }}
          </div>
          <div v-else class="walletconnect__value shimmer shimmer-text"></div>
        </div>
        <div
          class="d-flex flex-row justify-content-between align-items-center"
          v-if="selectedToken"
        >
          <div class="walletconnect__you_pay">
            {{ $t("walletconnect.youPay") }}
          </div>
          <div>
            <div v-if="isPayableDataLoaded" class="walletconnect__amount_field">
              {{ payableData?.payable_amount }}
              {{ payableData?.payable_currency }}
            </div>
            <div
              v-else
              class="walletconnect__amount_field shimmer shimmer-text"
            ></div>
            <!-- <div v-else-if="paymentStatus?.recievedAmount" class="walletconnect__amount_field">
              {{
                DecimalNumber(payableData?.payable_amount).minus(
                  paymentStatus?.recievedAmount || 0
                )
              }} {{ payableData?.payable_currency }}
            </div> -->
          </div>
        </div>
        <small class="error mt-2" v-if="error || customErrorMessage">
          {{
            error
              ? error?.message.split(":").length > 1
                ? error?.message.split(":")[
                    error?.message.split(":").length - 1
                  ]
                : error.message
              : customErrorMessage
              ? customErrorMessage.split(":").length > 1
                ? customErrorMessage.split(":")[
                    customErrorMessage.split(":").length - 1
                  ]
                : customErrorMessage
              : ""
          }}
        </small>
        <CustomButton
          className="walletconnect__pay_button mt-2"
          :disabled="!qrData || !selectedToken"
          @handle-click="handlePay($event)"
          :name="$t('walletconnect.pay')"
        />

        <button
          v-if="showsConnectedPayment"
          type="button"
          class="walletconnect__disconnect_button"
          @click="handleDisconnectModal(true)"
        >
          <svg
            class="walletconnect__disconnect_icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <polyline
              points="16 17 21 12 16 7"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <line
              x1="21"
              y1="12"
              x2="9"
              y2="12"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>{{ $t("walletconnect.changePaymentMethod") }}</span>
        </button>
      </div>
    </div>
    <div v-else>
      <div v-if="qrData" class="walletconnect__amount_field text-center">
        {{ payableData?.payable_amount }} {{ payableData?.payable_currency }}
      </div>
      <div v-else class="walletconnect__amount_field text-center">
        {{
          DecimalNumber(payableData?.payable_amount).minus(
            paymentStatus?.recievedAmount || 0
          )
        }}
      </div>
      <div class="walletconnect__connected_container margin-0">
        <img
          class="walletconnect__wallet_icon_connected"
          v-if="walletInfo?.icon || walletInfo?.image_url"
          :src="getLiveIcon(walletInfo)"
          @error="onImgError"
          alt=""
        />
        <div class="walletconnect__wallet_title_connected">
          {{ walletInfo?.name || "WalletConnect" }}
        </div>
      </div>
      <small class="error mt-2" v-if="error || customErrorMessage">
        {{
          error
            ? error?.message.split(":").length > 1
              ? error?.message.split(":")[error?.message.split(":").length - 1]
              : error.message
            : customErrorMessage
            ? customErrorMessage.split(":").length > 1
              ? customErrorMessage.split(":")[
                  customErrorMessage.split(":").length - 1
                ]
              : customErrorMessage
            : ""
        }}
      </small>
      <vertical-progress-bar
        :steps="paymentSteps"
        :active="transactionStatus"
      ></vertical-progress-bar>
    </div>
    <PopupModal
      v-if="isConnected"
      :title="$t('walletconnect.areYouSure')"
      id="disconnect-wallet"
      :showModal="disconnectModal"
      :description="$t('walletconnect.walletDisconnectMessage')"
      :cancel="$t('walletconnect.stay')"
      :icon="getLiveIcon(walletInfo)"
      :dismiss="$t('walletconnect.disconnect')"
      :error="onImgError"
      @cancelClicked="handleCancel"
      @dismissClicked="handleDisconnect()"
    />
  </div>
</template>
<script src="./script.js"></script>
<style src="./style.scss" lang="scss" scoped></style>
